module.exports = __webpack_public_path__ + "media/images/logos/c-map-cta-5f93b1d9d6014a6fdf9d136574a354e6.jpg";